import React from 'react'
import { Box, Button, TextField } from '@material-ui/core'
import { useFormik } from 'formik'
import * as Yup from 'yup'

import { LoadableButton } from '../../../components/Form'
import { ICorporationType } from '../../../graphql/types/businesses'

interface IProps {
  loading: boolean
  corporationType?: ICorporationType | null
  onSubmit: (values: ICorporateTypeFormValues) => void
  onCancel: () => void
}

export interface ICorporateTypeFormValues {
  name: string
}

const corporateTypeSchema = Yup.object().shape({
  name: Yup.string().required('Обязательное поле'),
})

export const CorporateTypeForm: React.FC<IProps> = ({ loading, corporationType, onSubmit, onCancel }) => {
  const formik = useFormik<ICorporateTypeFormValues>({
    initialValues: {
      name: corporationType?.name ?? '',
    },
    validationSchema: corporateTypeSchema,
    onSubmit(values, formikHelpers) {
      onSubmit(values)
    },
  })

  const { values, errors, handleChange, submitForm } = formik

  return (
    <div>
      <Box mb={2}>
        <TextField
          label='Название'
          name='name'
          value={values.name}
          onChange={handleChange}
          required
          fullWidth
          margin='normal'
          error={!!errors.name}
          helperText={errors.name}
        />

        <Box pt={4} pb={1} display='flex' flexDirection='row' justifyContent='space-between'>
          <Button onClick={onCancel}>Отмена</Button>
          <LoadableButton loading={loading} color='primary' variant='contained' onClick={submitForm}>
            Сохранить
          </LoadableButton>
        </Box>
      </Box>
    </div>
  )
}
